// TODO: MOVE IT TO JOB LISTING FEATURE
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {Grid, Typography} from '@mui/material';
import {InputAdornment, styled} from '@mui/material';

import TextField from '@jobseeker/lotus/elements/Input';
import {Image} from '@jobseeker/lotus/components/Image';
import {SearchIconGrey} from '@jobseeker/lotus/assets/icons';
import {isCSR} from '@jobseeker/lotus/utils';
import {useState, useRef, useEffect, useCallback} from 'react';
import {Button, ButtonV2, Select} from '@jobseeker/lotus/elements';
import kebabCase from 'lodash/kebabCase';

import {locations, sortBy} from '@jobseeker/lotus/components/JobSearchBar/data';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {JobSearchBarProps} from '@jobseeker/lotus/components/JobSearchBar/type';
import {locationMap} from '@jobseeker/lotus/utils';
import {useDispatch, useSelector} from 'react-redux';
import {getKeywordSearch} from '@jobseeker/feature-search/helpers';
import {
  /*EXPERIENCE_MAPPING,*/ EXPERIENCE_MAPPING,
  ROUTE_SEARCH,
} from '@constants';
import {
  handleTracking,
  TrackEventUBA,
  openUrl,
} from '@jobseeker/common-core/utils';
import {getRefTagAndOrigin} from './homeCategory';
import {AppState} from '@jobseeker/common-core/types';
import {getKeyFromPath} from '@utils';

const Listbox = styled('div')<any>(({theme, variant}: any) => ({
  width: 'calc(100% + 8px)',
  zIndex: 10,
  position: 'sticky',
  listStyle: 'none',
  boxShadow: '0 13px 14px 0 rgba(0,0,0,.13)',
  // padding: '8px 0',
  backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#000',
  overflow: 'auto',
  maxHeight: 650,
  // border: '1px solid',
  marginLeft: -8,
  // borderColor:
  //   variant === VersionVariants.VERSION_ONE ? '#bbb' : theme.palette.divider,
  borderRadius: variant === VersionVariants.VERSION_ONE ? 6 : 16,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  marginTop: 13,
  '& li.Mui-focused': {
    backgroundColor: '#4a8df6',
    color: 'white',
    cursor: 'pointer',
  },
  '& li:active': {
    backgroundColor: '#2977f5',
    color: 'white',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'calc(100% - 8px)', // Example: Change width for small screens
    marginTop: 0, // Example: Adjust zIndex on mobile
    marginLeft: 0,
  },
}));

const List = styled('li')(() => ({
  padding: '12px 16px',
  fontSize: '16px',
  ':hover': {
    backgroundColor: '#F2F5FA',
  },
}));

export const JobSearchBar = (props: JobSearchBarProps) => {
  const dispatch: any = useDispatch();
  const [searchFormValue, setsearchFormValue] = useState<any>({
    loc: [],
    experiences: [],
    sort: [],
    query: '',
  });
  const setSearchFormValue = useCallback(
    (value: any) => {
      setsearchFormValue(value);
      //   dispatch({
      //     type: 'job/jobFeed/set_filters',
      //     payload: {filters: value, options: {showSort: false}},
      //   });
    },
    [dispatch]
  );
  const onSearchFormChange = useCallback(
    (e: any, value: any) => {
      let formv: any = {};
      const _value = value || e.target.value;
      try {
        formv[e.target.name] = _value;
      } catch (error) {
        if (value === 'dialog') {
          formv = e;
        }
      }

      const newV = {...searchFormValue, ...formv};

      if (e.target.name === 'query') {
        setSearchFormValue(newV);
        if (_value.length > 1) {
          getKeywordSearch(_value).then(searchInfo => {
            setKeywordSearch(searchInfo);
          });
          setAutocomplete(true);
        }
      } else {
        requestAnimationFrame(() => {
          setTimeout(() => {
            setSearchFormValue(newV);
          }, 0);
        });
      }
    },
    [searchFormValue, setSearchFormValue]
  );
  const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string>('');

    useEffect(() => {
      if (typeof navigator !== 'undefined') {
        setUserAgent(navigator.userAgent || navigator.vendor || '');
      }
    }, []);

    return userAgent;
  };
  const userAgent = useUserAgent();
  const {userId} = useSelector((state: AppState) => state.auth);

  const handleSearchSubmit = (
    keyword: string,
    location: string,
    experience: {
      minexp: number;
      maxexp: number;
    },
    posting?: string[],
    filterData?: any
  ) => {
    const queryObject: any = {
      loc: location,
      minexp: experience?.minexp?.toString() ?? '',
      maxexp: experience?.maxexp?.toString() ?? '',
      posting: posting?.length ? posting?.join() ?? '' : '',
    };
    if (filterData?.industry) {
      queryObject.industry = filterData?.industry.join(',');
    }
    let queryString = '';
    if (Object.keys(queryObject)?.length > 0) {
      queryString = new URLSearchParams(queryObject).toString();
    }
    const url = `${ROUTE_SEARCH}/${keyword}?${queryString}&ref=homepage`;
    const {origin, refText} = getRefTagAndOrigin();

    handleTracking('jsActionSearch', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
      keywords: `${queryString}`,
      exp: `${queryObject.minexp}`,
      location: `${location}`,
    });

    TrackEventUBA('jsHomePageClick', 'click', {
      page: 'jsHomePage',
      section: 'Search',
      searchKeywords: queryString || '',
      filterExp: `${queryObject?.minexp}-${queryObject?.maxexp}` || '',
      filterLocation: queryObject?.loc || '',
      filterJobPosting: queryObject?.posting || '',
      ref: getKeyFromPath('ref') || '',
      sessionUsername: userId ? userId.toString() : '',
    });

    openUrl(url, '_self');
  };

  const onFilterSubmit = (filterData: any) => {
    const {experience, locationLabels} = filterData;
    const filterExp: object = EXPERIENCE_MAPPING[parseInt(experience)] ?? {};

    const locationLabel = locationLabels?.replace(/ /g, '-') || '';
    const query = kebabCase(filterData?.query?.toLowerCase().replace('&', ''));
    if (query) {
      handleSearchSubmit(
        query,
        locationLabel,
        filterExp as any,
        filterData.posting,
        filterData
      );
    }
  };

  const [keywordSearch, setKeywordSearch] = useState<string[]>([]);
  const [autocomplete, setAutocomplete] = useState<any>(false);
  const isFilterBar = props.isFilter;
  const {showAutocomplete, onAutoCompleteSelect, autocompleteList} = {
    showAutocomplete: autocomplete,
    onAutoCompleteSelect: () => setAutocomplete(false),
    autocompleteList: keywordSearch,
  };
  const [menuOpen, setOpen] = useState<any>(false);
  const textBarRef = useRef();
  const setMenuOpen = useCallback(
    (value: any) => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (value && value === menuOpen) {
            setOpen(false);
          } else setOpen(value);
        }, 0);
      });
    },
    [menuOpen]
  );

  useEffect(() => {
    if (!isCSR()) {
      return;
    }

    const handleScroll = () => {
      const scrollThreshold = 200;

      if (window.scrollY > scrollThreshold && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [menuOpen]);

  const submitFilter = () => {
    setTimeout(() => {
      setMenuOpen(false);
      const modifiedData: any = {};
      if (
        Array.isArray(searchFormValue?.loc) &&
        searchFormValue?.loc.length > 0
      ) {
        modifiedData.locationLabels = locationMap(searchFormValue?.loc);
      }
      if (
        Array.isArray(searchFormValue?.sort) &&
        searchFormValue?.sort.length > 0
      ) {
        modifiedData.sort = searchFormValue?.sort?.map(
          (s: string | number) =>
            sortBy.find(sb => sb.value == s)?.label.toLowerCase()
        );
      }
      onFilterSubmit && onFilterSubmit({...searchFormValue, ...modifiedData});
    }, 0);
  };

  const eventCallback = (e: any) => {
    if (e?.target?.name === 'query') {
    } else {
      if (onAutoCompleteSelect) {
        onAutoCompleteSelect();
      }
    }
    if (e?.target?.getAttribute('data-name') === 'navbar-search') {
      setMenuOpen(false);
    }
  };
  useEffect(() => {
    window?.addEventListener('click', eventCallback);

    return () => {
      window.removeEventListener('click', eventCallback);
    };
  }, []);

  const onFilterChange = useCallback(
    (e: any, value?: any) => {
      if (onSearchFormChange) {
        onSearchFormChange(e, value);
      }
    },
    [onSearchFormChange]
  );
  const onFormSubmit = (e: any) => {
    e.preventDefault();
    submitFilter();
  };
  const textClick = (e: any) => {
    setMenuOpen(false);
    // textBarRef.current.focus();
  };

  const onAutoCompleteListClick = (value: string) => {
    onFilterChange({target: {name: 'query', value}}, value);
    if (onAutoCompleteSelect) {
      onAutoCompleteSelect();
    }
  };
  const onlySpecialCharRegex = /^[^a-zA-Z0-9]+$/;
  const isInputDisabled =
    props.showSearchInput &&
    (onlySpecialCharRegex.test(searchFormValue?.query) ||
      !searchFormValue?.query?.trim());

  const css_props: any = props.inline
    ? {
        flexDirection: {
          xxs: props.onlySeachInput ? 'row' : 'column',
          // md: 'row',
          md: 'row',
        },
        width: {xxs: 12, md: 5.5},
        fontSize: 12,
        sort: {lg: false},
        button: (
          <ButtonV2
            variant="contained"
            sx={{
              marginTop: {xxs: 2, md: 0},
              height: '48px',
              zIndex: 2,
              width: {xxs: '100%', md: '100%'},
              fontSize: {xxs: 12, xs: 16},
              lineHeight: {xxs: '12px', xs: '16px'},
              px: {xxs: 1, md: 3},
              py: {xxs: 1.5, md: 2},
              borderRadius: '8px',

              '&:hover': {
                backgroundColor: '#E9630C',
              },

              background: '#E9630C',

              backgroundColor: '#E9630C',
            }}
            onClick={submitFilter}
          >
            <Typography fontWeight={'bold'}>
              {isFilterBar ? 'Filter' : 'Search'}
            </Typography>
          </ButtonV2>
        ),
      }
    : {
        flexDirection: {
          xxs: props.onlySeachInput ? 'row' : 'column',
          lg: 'row',
          md: 'column',
        },
        width: {xxs: 12, lg: 4},
        fontSize: 14,
        sort: {lg: true},
        button: (
          <ButtonV2
            type="submit"
            variant="outlined"
            disabled={isInputDisabled}
            sx={{
              zIndex: 2,
              width: {xxs: 'fit-content', md: '100%'},
              fontSize: {xxs: 12, xs: 16},
              lineHeight: {xxs: '12px', xs: '16px'},
              px: {xxs: 1, md: 2.5},
              py: {xxs: 1, md: 1},
              pl: {xxs: 1.5, md: 2.5},
              '.MuiButton-startIcon': {
                mr: {xxs: 0.5, md: 1},
              },
              ':hover': {
                backgroundColor: 'secondary.main',
                borderColor: 'secondary.main',
                '.searchbar-icon': {
                  filter: 'brightness(10)',
                },
                color: '#fff',
                '*': {
                  color: '#fff',
                },
              },
            }}
            onClick={submitFilter}
          >
            {isFilterBar ? 'Filter' : 'Search'}
          </ButtonV2>
        ),
      };
  const handleKeyPress = (e: any) => {
    if (e?.key === 'Enter') {
      isInputDisabled ? () => {} : submitFilter();
    }
  };

  return (
    <Grid
      component={'form'}
      onSubmit={onFormSubmit}
      container
      spacing={{xxs: 1, md: 0}}
      sx={{flexDirection: css_props.flexDirection}}
      flexWrap={{xxs: 'nowrap', md: 'unset'}}
      onKeyDown={handleKeyPress}
      mb={{xxs: '48px', md: 0}}
    >
      {!isFilterBar && props.showSearchInput && (
        <Grid
          item
          xxs={css_props.width.xxs}
          md={css_props.width.md}
          lg={css_props.width.lg}
          sx={{position: 'relative'}}
          mt={{xxs: 0, md: -0.4}}
        >
          <TextField
            inputRef={textBarRef}
            size="small"
            onClick={textClick}
            placeholder="Search Jobs"
            variant={props.variant}
            aria-autocomplete="list"
            aria-expanded="true"
            autoComplete="off"
            spellCheck="false"
            aria-invalid="false"
            name="query"
            onChange={onFilterChange}
            error={searchFormValue?.query && isInputDisabled}
            helperText={
              searchFormValue?.query && isInputDisabled
                ? 'Only special character and spaces are not allowed'
                : ''
            }
            hirist={true}
            sx={{
              zIndex: 3,
              fontSize: 17,
              borderRadius: '8px',

              '.MuiInputBase-root': {
                borderRadius: '8px',
                pl: {xxs: 1.5, md: 0},

                height: '55px !important',
                fontSize: 17,
              },

              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                height: '55px !important',
                fontSize: 17,
                border: '1px #7E7E7E33 !important', // Remove any border
                boxShadow: 'none !important', // Prevents shadow effect
                '&:hover': {
                  border: '1px #7E7E7E33 !important', // Remove any border
                  boxShadow: 'none !important',
                },
                '&.Mui-focused': {
                  border: '1px #7E7E7E33 !important', // Remove any border
                  boxShadow: 'none !important',
                },
              },

              '& .MuiInputBase-root': {
                borderRadius: '8px',
                pl: {xxs: 1.5, md: 0},
                height: '55px !important',
                fontSize: 17,
              },

              '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #7E7E7E33 !important', // Always visible border
                display: {xxs: 'inline', md: 'none !important'},
              },
            }}
            value={searchFormValue?.query}
            InputProps={{
              style: {height: '39px', backgroundColor: 'white'},
              startAdornment: (
                <InputAdornment position="start">
                  <Image
                    src={SearchIconGrey}
                    alt={'Search'}
                    width={18}
                    height={18}
                  />
                </InputAdornment>
              ),
            }}
          />
          {showAutocomplete &&
            autocompleteList &&
            autocompleteList?.length > 0 && (
              <Listbox
                variant={props.variant}
                sx={{
                  position: 'absolute',
                }}
              >
                {autocompleteList?.map((keyword: any, index: any) => (
                  <List
                    style={{cursor: 'default'}}
                    key={`searchform-keyword-${index}`}
                    onClick={e => onAutoCompleteListClick(keyword)}
                  >
                    {keyword}
                  </List>
                ))}
              </Listbox>
            )}
        </Grid>
      )}
      <Grid item xxs {...css_props.sort}>
        <Grid container spacing={{xxs: 1, md: 0}} sx={{alignItems: 'center'}}>
          {isFilterBar && props.showSortBy && !props.onlySeachInput && (
            <Grid item xxs={12} sm md>
              <Select
                menuOpen={menuOpen === 'sort'}
                setMenuOpen={setMenuOpen}
                variant={props.variant}
                options={sortBy}
                label={'Sort By'}
                value={searchFormValue?.sort}
                name="sort"
                onChange={onFilterChange}
              />
            </Grid>
          )}
          {!props.onlySeachInput && (
            <>
              {!props?.hideLocationBar && (
                <Grid item xxs={12} sm md>
                  <Select
                    hirist={true}
                    menuOpen={menuOpen === 'loc'}
                    setMenuOpen={setMenuOpen}
                    variant={props.variant}
                    options={locations}
                    label={'Locations'}
                    name="loc"
                    value={searchFormValue?.loc}
                    multiple={true}
                    onChange={onFilterChange}
                    MenuProps={{
                      disablePortal: true,
                    }}
                  />
                </Grid>
              )}
              <Grid
                item
                xxs={12}
                sm
                md
                sx={
                  props?.hideLocationBar
                    ? {
                        display: 'flex',
                        justifyContent: 'end',
                      }
                    : {}
                }
              >
                <Select
                  hirist={true}
                  menuOpen={menuOpen === 'experience'}
                  setMenuOpen={setMenuOpen}
                  maxWidth={props?.hideLocationBar ? 220 : 0}
                  variant={props.variant}
                  options={[
                    {value: 0, label: 'Any Exp. Level'},
                    {value: 1, label: '0 - 1 yrs'},
                    {value: 2, label: '2 - 3 yrs'},
                    {value: 3, label: '4 - 6 yrs'},
                    {value: 4, label: '7 - 10 yrs'},
                    {value: 5, label: '11 - 15 yrs'},
                    {value: 6, label: '16 - 20 yrs'},
                    {value: 7, label: '21 - 25 yrs'},
                    {value: 8, label: '26+ yrs'},
                  ]}
                  value={searchFormValue?.experience}
                  label={'Experience'}
                  name="experience"
                  onChange={onFilterChange}
                  MenuProps={{
                    disablePortal: true,
                  }}
                />
              </Grid>
            </>
          )}

          <Grid
            item
            xxs={12}
            sm={props.inline ? true : 'auto'}
            md={props.inline ? 2.5 : 'auto'}
            sx={{
              paddingLeft: {md: 0},
            }}
          >
            {props.variant === VersionVariants.VERSION_ONE ? (
              <Button
                type="submit"
                variant="contained"
                sx={{px: 4, fontSize: '18px', width: '100%'}}
                size="small"
                disabled={isInputDisabled}
                onClick={submitFilter}
              >
                {isFilterBar ? 'Filter' : 'Search'}
              </Button>
            ) : (
              css_props.button
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    // </form>
  );
};
